<template>
  <div>
    <b-modal 
      centered 
      id="ModalAdvanceFiltersPricesLists" 
      size="md"
      modal-class="custom-dialog dialog-600"
      title="Búsqueda Avanzada"
      @ok="ok"
      ok-variant="warning"
      :ok-title="$t('Buscar')"
      ok-only
      @close="close"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template>
        <form-render :form.sync="form" :fields="fields" :key="keyFormRender" ref="formAdvanceFiltersPricesLists" @send="sendForm">
        </form-render>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'

export default {
  name: 'modal-advance-filters-prices-lists',
  props: {
    dataFilters: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      required: true
    },
    closeModal: {
      type: Function,
      default: () => {}
    },
    sendFormData: {
      type: Function,
      default: () => {}
    }
  }, 
  data() {
    return {
      baseService: new BaseServices(this),
      fields: [],
      keyFormRender: 0
    }
  },
  mounted() {
    this.setInitialData()
    if (this.form?.country) {
      this.changeCountry('country', this.form.country)
    }
  },
  computed: {
    ...mapGetters({
      carriers: 'getCarriersForCountry',
      services: 'getServicesByCountryCarrier',
      generalLoading: 'getLoading'
    })
  },
  watch: {
    carriers() {
      this.setOptions('carriers', 'carrier')
      const resetFields = ['carrier']
      resetFields.forEach(el => this.setSkeletonField(el, false))
      if (this.form?.carrier) {
        this.form.carrier = this.dataFilters.form.carrier
        this.changeCourier('carrier', this.form.carrier)
      }
    },
    services() {
      this.setOptions('services', 'service')
      const resetFields = ['service']
      resetFields.forEach(el => this.setSkeletonField(el, false))
    }
  },
  methods: {
    setInitialData() {
      this.fields = [
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'country', label: 'País', validation: 'required', containerClass: 'container-info col-sm-12 col-md-12 col-lg-12', change: this.changeCountry, addFlags: true, sort: true, options: this.dataFilters.countries || [] },
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'carrier', label: 'Courier', validation: 'required', containerClass: 'container-info col-sm-12 col-md-12 col-lg-12', dependency: 'country', change: this.changeCourier, sort: true },
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'service', label: 'Servicio', containerClass: 'container-info col-sm-12 col-md-12 col-lg-12', dependency: 'carrier', sort: true },
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'idSeller', type: 'text', label: 'ID Usuario', containerClass: 'container-info col-sm-12 col-md-12 col-lg-12', change: this.changeIdSeller, dependency: 'country', searchOnType: { fx: this.setSeller, nChars: 2, debounce: 600, allowSearchAsValue: false, persistSearch: true } }
      ]
    },
    setOptions(name, fieldName) {
      this.fields[this.m_getElementIndex(this.fields, 'name', fieldName)].options = this[name].rows
    },
    setSkeletonField (name, bool) {
      this.fields[this.m_getElementIndex(this.fields, 'name', name)].useSkeleton = bool
      this.fields[this.m_getElementIndex(this.fields, 'name', name)].useLabel = bool
    },
    changeCountry(name, value) {
      if (value) {
        this.setSkeletonField('carrier', true)
        this.$store.dispatch('fetchService', { name: 'getCarriersForCountry', params: { country_id: value.id } })
      }
      delete this.form.service
      delete this.form.idSeller

    },
    changeCourier(name, value) {
      if (value) {
        this.setSkeletonField('service', true)
        const params = { country_id: this.form.country.id, carrier_id: this.form.carrier.id}
        this.$store.dispatch('fetchService', { name: 'getServicesByCountryCarrier', params})
      }
      delete this.form.service
    },
    async setSeller(value) {
      if (!this.form.country?.id) return []
      const params = { country_id: this.form.country.id }
      const queryParams = { search: value, include_shippers: true }
      try {
        const resp = await this.baseService.callService('getSeller', queryParams, params)
        return resp.data.organizations.map(el => ({ ...el, text: el.fullname, valid: true }))
      } catch (err) {
        this.$newError('Error', err.message, 'large')
        return []
      }
    },
    async ok(e) {
      e.preventDefault()
      const validate = await this.$refs.formAdvanceFiltersPricesLists.checkForm()
      console.log('validate', validate)
      if (validate) this.sendForm()
    },
    sendForm() {
      this.$emit('sendFormData', this.form)
      this.close()
    },
    close() {
      this.$emit('closeModal', 'ModalAdvanceFiltersPricesLists')
    }
  }
}
</script>